import { AbstractControl, ValidatorFn } from '@angular/forms';

export function factorPoints(pointsMax: number, factor: number): ValidatorFn {
	return (control: AbstractControl) => {
		if (!control.value || !pointsMax) {
			return null;
		}
		const pointsTimesFactor = Math.floor(+control.value * (factor || 1));
		const lessThanMax = pointsTimesFactor <= pointsMax;

		if (lessThanMax) {
			return null;
		} else {
			return { pointsMax: true };
		}
	};
}
